import React, { PureComponent } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import classes from "./styles.module.scss";

class HeadLine extends PureComponent {
    render() {
        const { label, className } = this.props;
        return (
            <h1 className={ cn(classes.title, {[className]: className}) }>{ label }</h1>
        );
    }
}

HeadLine.defaultProps = {
    className: null,
};

HeadLine.propTypes = {
    label: PropTypes.string.isRequired,
    className: PropTypes.object,
};

export default HeadLine;
